const Portfolio_data = [
  {
    id: 1,
    project: "Aloha Convention Center",
    image: "https://i.ibb.co/cNZJ2jm/Convention-Center.jpg",
    live_url: "https://convention-center-robinrakibul.netlify.app/",
  },
  {
    id: 2,
    project: "Binge Movies",
    image: "https://i.ibb.co/VmRTk0t/Binge-Movies.jpg",
    live_url: "https://binge-movie-react-app.netlify.app/",
  },
  {
    id: 3,
    project: "Recipe Search",
    image: "https://i.ibb.co/TqxJw40/Recipe-Search.jpg",
    live_url: "https://robinrakibul.github.io/recipe-search-ingredients-js/",
  },
  {
    id: 4,
    project: "Quote Generator",
    image: "https://i.ibb.co/DKJ8DT5/Quote-Generator.jpg",
    live_url: "https://quote-generator-api-js.netlify.app/",
  },
  {
    id: 5,
    project: "Weather Checker",
    image: "https://i.ibb.co/H2LDcm2/Weather-Checker.jpg",
    live_url: "https://robinrakibul.github.io/weather-check-with-api/",
  },
  {
    id: 6,
    project: "Phone Search",
    image: "https://i.ibb.co/jZy9C1F/Phonezone.jpg",
    live_url: "https://phone-hunter-8077a1.netlify.app/",
  },
  {
    id: 7,
    project: "Smart Savings",
    image: "https://i.ibb.co/sPdjdks/Smart-Savings.jpg",
    live_url: "https://money-master-robinrakibul.netlify.app/",
  },
  {
    id: 8,
    project: "SMS Bomber",
    image: "https://i.ibb.co/xFBryJb/Screenshot-2022-07-02-120510.jpg",
    live_url: "https://smsbomber.netlify.app/",
  },
  {
    id: 9,
    project: "Expense Tracker System",
    image: "https://i.ibb.co/qgvxxN6/Expense-Tracker-System.jpg",
    live_url: "https://expense-tracker-system-php.000webhostapp.com/",
  }
]
export default Portfolio_data
